import { supabase } from '../supabaseClient';

export const clientTasksService = {
    async getByClientId(clientId) {
        const { data, error } = await supabase
            .from('client_tasks')
            .select('*')
            .eq('client_id', clientId)
            .order('due_date', { ascending: true });
        if (error) throw error;
        return data || [];
    },

    async getPendingByAgentNpn(agentNpn) {
        const { data, error } = await supabase
            .from('client_tasks')
            .select(`
        *,
        agent_clients:client_id(name, email)
      `)
            .eq('agent_npn', agentNpn)
            .eq('status', 'pending')
            .order('due_date', { ascending: true });
        if (error) throw error;
        return data || [];
    },

    async getOverdueByAgentNpn(agentNpn) {
        const now = new Date().toISOString();
        const { data, error } = await supabase
            .from('client_tasks')
            .select(`
        *,
        agent_clients:client_id(name, email)
      `)
            .eq('agent_npn', agentNpn)
            .eq('status', 'pending')
            .lt('due_date', now)
            .order('due_date', { ascending: true });
        if (error) throw error;
        return data || [];
    },

    async create(task) {
        const { data, error } = await supabase
            .from('client_tasks')
            .insert([task])
            .select()
            .single();
        if (error) throw error;
        return data;
    },

    async update(id, updates) {
        const updateData = { ...updates };
        // Si se marca como completada, agregar completed_at
        if (updates.status === 'completed' && !updates.completed_at) {
            updateData.completed_at = new Date().toISOString();
        }
        // Si se cambia de completada a otra cosa, limpiar completed_at
        if (updates.status !== 'completed' && updates.status) {
            updateData.completed_at = null;
        }

        const { data, error } = await supabase
            .from('client_tasks')
            .update(updateData)
            .eq('id', id)
            .select()
            .single();
        if (error) throw error;
        return data;
    },

    async delete(id) {
        const { error } = await supabase
            .from('client_tasks')
            .delete()
            .eq('id', id);
        if (error) throw error;
    }
};
